/* eslint-disable no-confusing-arrow */
/* eslint-disable react/self-closing-comp */
/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
import React, { useEffect, useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Form, Field, FormSpy } from 'react-final-form';
import { toastr } from 'react-redux-toastr';
import { push } from 'react-router-redux';

import Layout from '../layout';
import FormField from '../checkout-steps/shared/form-field';
import countryField from '../checkout-steps/address/country-field';
import stateField from '../checkout-steps/address/state-field';
import CountryAPI from '../../apis/country';
import validators from '../shared/validators';
import { formatCreditCardNumber, formatCVC, formatExpirationDate, formatMoney } from '../../helper';
import CreditCard from '../../services/credit-card';
import UserUtils from '../../services/user-utils';
import spreeStore from '../../store';
import APP_ROUTES from '../../constants/app-routes';

import loadingStyles from '../styles/components/loading.scss';
import WalletsAPI from '../../apis/wallets';

const AddFundsKWallet = (props) => {
    const { intl } = props;

    const [ccType, setCcType] = useState('generic');
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState('');

    const showGenericToastError = () => {
        toastr.error(
            intl.formatMessage({ id: 'generic-error-title', defaultMessage: 'Something went wrong' }),
            intl.formatMessage({ id: 'generic-error-message', defaultMessage: 'Please try again' }),
        );
    };

    const composeValidators = (...validators) => (value) => validators.reduce((error, validator) => error || validator(value), undefined);
    const amountValidator = () => (value) => (!Number.isNaN(value) && value >= 0 ? undefined : <FormattedMessage id="add-funds-k-wallet-invalid-amount-error" defaultMessage="Only positive numbers are allowed. Use (.) to specify cents" />);
    const requiredValidaror = (value) => (value ? undefined : <FormattedMessage id="required-message" defaultMessage="Required" />);
    const zipcodeAdapterValidator = (value) => (validators.zipCode(value) === undefined ? undefined : <FormattedMessage id="invalid-zip-code" defaultMessage="Invalid ZIP Code" />);
    const phoneAdapterValidator = (value) => (validators.phone(value) === undefined ? undefined : <FormattedMessage id="invalid-phone-number" defaultMessage="Invalid phone number" />);
    const cardNumberLengthAdapterValidator = (value) => (validators.cardNumberLength(value) === undefined ? undefined : <FormattedMessage id="add-funds-k-wallet-invalid-card-number-error" defaultMessage="Invalid card number" />);

    const checkCCType = (num) => {
        const currentCCType = CreditCard.ccType(num);
        if (currentCCType !== ccType) {
            setCcType(currentCCType);
        }
    };

    useEffect(() => {
        if (!UserUtils.isLoggedIn()) {
            spreeStore.dispatch(push(APP_ROUTES.homePageRoute));
        }
    });

    useEffect(() => {
        async function getCountries() {
            try {
                const response = await CountryAPI.getCountryList({ availableName: 'available_for_billing_true' });
                if (countries && countries.length !== response.body.countries.length) {
                    setCountries(response.body.countries);
                }
            } catch (err) {
                console.error(err);
                showGenericToastError();
            }
        }
        if (countries.length === 0) {
            getCountries();
        }
    });

    useEffect(() => {
        async function getStates() {
            try {
                const country = countries.find((curr) => curr.iso === selectedCountry);
                if (country) {
                    const response = await CountryAPI.getStatesByCountry({ availableName: 'available_for_billing_true', countryId: country.id });
                    setStates(response.body.states.length > 0 ? response.body.states : []);
                }
            } catch (err) {
                console.error(err);
                showGenericToastError();
            }
        }
        getStates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [countries, selectedCountry]);

    const getMakeADepositPayload = (values) => {
        const cardNumber = values.cardNumber.trim().replaceAll(' ', '');
        const expirationDate = formatExpirationDate(values.expirationDate);
        const [expirationDateMonth, expirationDateYear] = expirationDate.split('/');
        return {
            amount: values.amount,
            notes: '',
            card: {
                number: cardNumber,
                name_in_card: values.nameOnCard,
                expiration_date_month: parseInt(expirationDateMonth, 10),
                expiration_date_year: parseInt(expirationDateYear.slice(0, 2), 10),
                ccv: values.cvv,
                address: values.address2 ? `${values.address1} ${values.address2}` : values.address1,
                city: values.city,
                state: values.stateName,
                zip_code: values.zipcode,
                country: values.countryIso,
            },
        };
    };

    const onSubmit = async (values) => {
        try {
            const binLookupInfo = await CreditCard.getBinLookupInfo(values.cardNumber);
            if (binLookupInfo && binLookupInfo.type === 'debit') {
                const { auth: { access_token: accessToken } } = spreeStore.getState();
                const payload = getMakeADepositPayload(values);
                await WalletsAPI.makeADeposit({
                    wallet: 'kwallet',
                    token: accessToken,
                    params: payload,
                });
                toastr.success(
                    intl.formatMessage({ id: 'well', defaultMessage: 'Well done' }),
                    intl.formatMessage({ id: 'add-funds-k-wallet-submitted-successfully', defaultMessage: 'add-funds-k-wallet-submitted-successfully' }),
                );
                spreeStore.dispatch(push(APP_ROUTES.manageKWallet));
            } else {
                toastr.error(
                    intl.formatMessage({ id: 'add-funds-k-wallet-invalid-debit-card-error-title', defaultMessage: 'Invalid debit card' }),
                    intl.formatMessage({ id: 'add-funds-k-wallet-invalid-debit-card-error-message', defaultMessage: 'Please provide a valid debit card' }),
                );
            }
        } catch (err) {
            console.error(err);
            if (err.message) {
                toastr.error(
                    intl.formatMessage({ id: 'generic-error-title', defaultMessage: 'Something went wrong' }),
                    err.message,
                );
            } else {
                showGenericToastError();
            }
        }
    };

    const cancelAddFunds = () => spreeStore.dispatch(push(APP_ROUTES.manageKWallet));

    return (
        <Layout>
            <div className="body-container manager-k-wallet">
                <div className="container">
                    <div className="formWrapper">
                        <Form
                            onSubmit={onSubmit}
                            render={({ handleSubmit, form, submitting, pristine, values, errors }) => (
                                <form onSubmit={handleSubmit}>
                                    <div className="add-funds-k-wallet">
                                        <div className="add-funds-k-wallet__title">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="#d3af71" className="bi bi-wallet-fill" viewBox="0 0 16 16">
                                                <path d="M1.5 2A1.5 1.5 0 0 0 0 3.5v2h6a.5.5 0 0 1 .5.5c0 .253.08.644.306.958.207.288.557.542 1.194.542.637 0 .987-.254 1.194-.542.226-.314.306-.705.306-.958a.5.5 0 0 1 .5-.5h6v-2A1.5 1.5 0 0 0 14.5 2h-13z" />
                                                <path d="M16 6.5h-5.551a2.678 2.678 0 0 1-.443 1.042C9.613 8.088 8.963 8.5 8 8.5c-.963 0-1.613-.412-2.006-.958A2.679 2.679 0 0 1 5.551 6.5H0v6A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-6z" />
                                            </svg>
                                            <div className="checkout-section-title__text-container">
                                                <FormattedMessage id="add-funds-k-wallet-title" defaultMessage="add-funds-k-wallet-title" />
                                            </div>
                                        </div>
                                        <div className="add-funds-k-wallet__body">
                                            <div className="add-funds-k-wallet__body__left-side">
                                                <div>
                                                    <Field
                                                        className="form-control"
                                                        name="amount"
                                                        component={FormField.inputFieldMarkup}
                                                        label={intl.formatMessage({ id: 'add-funds-k-wallet-amount', defaultMessage: 'Cantidad a agregar' })}
                                                        placeholder={intl.formatMessage({ id: 'add-funds-k-wallet-amount', defaultMessage: 'Cantidad a agregar' })}
                                                        type="tel"
                                                        validate={composeValidators(requiredValidaror, amountValidator())}
                                                        format={formatMoney}
                                                    />
                                                </div>
                                                <div>
                                                    <Field
                                                        name="nameOnCard"
                                                        component={FormField.inputFieldMarkup}
                                                        type="text"
                                                        placeholder={intl.formatMessage({ id: 'nameOnCard', defaultMessage: 'Name on card' })}
                                                        label={intl.formatMessage({ id: 'nameOnCard', defaultMessage: 'Name on card' })}
                                                        validate={requiredValidaror}
                                                    />
                                                </div>
                                                <div>
                                                    <div className="cc-number-wrapper">
                                                        <div className="cc-number-wrapper__input">
                                                            <Field
                                                                className="form-control"
                                                                name="cardNumber"
                                                                component={FormField.inputFieldMarkup}
                                                                placeholder={intl.formatMessage({ id: 'cardNumber', defaultMessage: 'Card Number' })}
                                                                label={intl.formatMessage({ id: 'cardNumber', defaultMessage: 'Card Number' })}
                                                                type="tel"
                                                                format={formatCreditCardNumber}
                                                                validate={composeValidators(requiredValidaror, cardNumberLengthAdapterValidator)}
                                                            />
                                                        </div>
                                                        <div className="cc-number-wrapper__card-logo">
                                                            <img src={`/pay-types/${ccType}-logo.png`} alt="CC logo" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="add-funds-k-wallet__body__form-twin-fields">
                                                    <div className="add-funds-k-wallet__body__form-twin-fields__field">
                                                        <Field
                                                            className="form-control"
                                                            name="expirationDate"
                                                            component={FormField.inputFieldMarkup}
                                                            label={intl.formatMessage({ id: 'cardExpiration', defaultMessage: 'Card Expiration' })}
                                                            placeholder={intl.formatMessage({ id: 'card-expiry-placeholder', defaultMessage: 'Expiration' })}
                                                            type="tel"
                                                            format={formatExpirationDate}
                                                            validate={requiredValidaror}
                                                        />
                                                    </div>
                                                    <div className="add-funds-k-wallet__body__form-twin-fields__field">
                                                        <Field
                                                            className="form-control"
                                                            name="cvv"
                                                            component={FormField.inputFieldMarkup}
                                                            label="CVV*"
                                                            placeholder={intl.formatMessage({ id: 'security-digits', defaultMessage: 'Security digits' })}
                                                            type="tel"
                                                            format={formatCVC}
                                                            validate={requiredValidaror}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="add-funds-k-wallet__body__right-side">
                                                <div>
                                                    <Field
                                                        className="form-control"
                                                        name="address1"
                                                        component={FormField.inputFieldMarkup}
                                                        label={intl.formatMessage({ id: 'address1', defaultMessage: 'Address Line 1' })}
                                                        type="text"
                                                        validate={requiredValidaror}
                                                    />
                                                </div>
                                                <div>
                                                    <Field
                                                        className="form-control"
                                                        name="address2"
                                                        component={FormField.inputFieldMarkup}
                                                        label={intl.formatMessage({ id: 'address2', defaultMessage: 'Address Line 2' })}
                                                        type="text"
                                                    />
                                                </div>
                                                <div className="add-funds-k-wallet__body__form-3-in-row-fields">
                                                    <div className="add-funds-k-wallet__body__form-3-in-row-fields__field">
                                                        <Field
                                                            className="form-control"
                                                            name="city"
                                                            component={FormField.inputFieldMarkup}
                                                            label={intl.formatMessage({ id: 'city', defaultMessage: 'City' })}
                                                            type="text"
                                                            validate={requiredValidaror}
                                                        />
                                                    </div>
                                                    <div className="add-funds-k-wallet__body__form-3-in-row-fields__field">
                                                        <div className="checkout-form-row">
                                                            <label htmlFor="country" className="checkout-form-label">
                                                                <FormattedMessage id="country" defaultMessage="Country" />
                                                            </label>
                                                            <div className="checkout-form-fields">
                                                                <Field
                                                                    name="countryIso"
                                                                    selectedCountryIso={selectedCountry}
                                                                    countries={countries}
                                                                    component={countryField}
                                                                    validate={requiredValidaror}
                                                                    handleCountryChange={(country) => setSelectedCountry(country)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="add-funds-k-wallet__body__form-3-in-row-fields__field">
                                                        <div className="checkout-form-row">
                                                            <label htmlFor="state" className="checkout-form-label">
                                                                <FormattedMessage id="state" defaultMessage="State" />
                                                            </label>
                                                            <div className="checkout-form-fields">
                                                                <Field
                                                                    name="stateName"
                                                                    states={states}
                                                                    component={stateField}
                                                                    validate={requiredValidaror}
                                                                    handleStateChange={() => {}}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="add-funds-k-wallet__body__form-twin-fields">
                                                    <div className="add-funds-k-wallet__body__form-twin-fields__field">
                                                        <Field
                                                            className="form-control"
                                                            name="zipcode"
                                                            component={FormField.inputFieldMarkup}
                                                            label={intl.formatMessage({ id: 'zipCode', defaultMessage: 'Zipcode' })}
                                                            type="text"
                                                            validate={composeValidators(requiredValidaror, zipcodeAdapterValidator)}
                                                        />
                                                    </div>
                                                    <div className="add-funds-k-wallet__body__form-twin-fields__field">
                                                        <Field
                                                            className="form-control"
                                                            name="phone"
                                                            component={FormField.inputFieldMarkup}
                                                            label={intl.formatMessage({ id: 'phone', defaultMessage: 'Phone' })}
                                                            type="text"
                                                            validate={composeValidators(requiredValidaror, phoneAdapterValidator)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            {submitting && (
                                                <div className="generic-processing">
                                                    <div className={loadingStyles.spinnerDark} />
                                                </div>
                                            )}
                                        </div>
                                        <div className="add-funds-k-wallet__actions">
                                            <button style={{ marginRight: '15px' }} className="button--outlined" type="submit" disabled={submitting || pristine || Object.keys(errors).length > 0}>
                                                <span className="checkout-button-text__desktop">
                                                    <FormattedMessage id="savePaymentMethod" defaultMessage="Save Payment Details" />
                                                </span>
                                            </button>
                                            <button className="button--outlined" type="button" disabled={submitting} onClick={() => cancelAddFunds()}>
                                                <span className="checkout-button-text__desktop">
                                                    <FormattedMessage id="modal-change-municipality-button-cancel" defaultMessage="Cancelar" />
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                    <FormSpy
                                        subscription={{ values: true }}
                                        onChange={(props) => {
                                            checkCCType(props.values.cardNumber);
                                        }}
                                    />
                                </form>
                            )}
                        />
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default injectIntl(AddFundsKWallet);



/** WEBPACK FOOTER **
 ** ./src/components/pages/add-funds-k-wallet.jsx
 **/